import { Layout, Page } from "@apex/component-library";
import { Box } from "@chakra-ui/react";

import ExportToolSearch from "../components/ExportToolSearch";
import { withPermissions } from "../hoc/withPermissions";
import { Permissions } from "../permissions";

export interface ExportPageProps {}

const ExportPage = (props: ExportPageProps) => {
  return (
    <Page>
      <Layout type="fullWidth">
        <Box mx={-4} mt={-4}>
          <ExportToolSearch />
        </Box>
      </Layout>
    </Page>
  );
};

export default withPermissions(ExportPage, [
  Permissions.AccountRead,
  Permissions.MarginProcessingUiNavView,
]);
